import { GoogleAdsState } from '../interfaces/googleAds';
import googleAdsCRUDActions from '../actions/GoogleAdsCRUDActions';
import {
  deleteLocalFirst,
  retrieved,
  setBusy,
  setUnBusy,
} from './common/commonReducers';
import Actions from '../actions/actions';
import AdAudienceModel from '../model/AdAudienceModel';
import _ from 'lodash';

const initial: GoogleAdsState = {
  busy: false,
  entities: [],
};

const checkIfIdUnique = (
  prevItem: AdAudienceModel,
  nextItem: AdAudienceModel,
) => prevItem.id === nextItem.id;

const unionUniqueById = (
  prevEntities: AdAudienceModel[],
  nextEntities: AdAudienceModel[],
) => _.unionWith(prevEntities, nextEntities, checkIfIdUnique);

const retrievedAll = (state: GoogleAdsState, action): GoogleAdsState => {
  const { entities: nextEntities } = action;
  const { entities: prevEntities } = state;

  return {
    ...state,
    entities: unionUniqueById(prevEntities || [], nextEntities),
    busy: false,
  };
};

export const googleAds = (state: GoogleAdsState = initial, action: any) => {
  switch (action.type) {
    case googleAdsCRUDActions.retrievedAction:
      return retrieved(state, action);
    case googleAdsCRUDActions.busyAction:
      return setBusy(state);
    case googleAdsCRUDActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case googleAdsCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case googleAdsCRUDActions.unbusyAction:
      return setUnBusy(state);
    case googleAdsCRUDActions.retrieveGoogleClientCredentialsAction:
      return {
        ...state,
        busy: true,
      };
    case googleAdsCRUDActions.retrieveGoogleClientCredentialsSuccessAction:
      return {
        ...state,
        busy: false,
        credentials: action.payload,
      };
    case googleAdsCRUDActions.retrieveGoogleClientCredentialsErrorAction:
      return {
        ...state,
        busy: false,
      };
    case googleAdsCRUDActions.resetAction:
    case Actions.RESET:
      return initial;
    default:
      return state;
  }
};
